import React, { useEffect, useRef, useState } from "react";

// Fixed, full-viewport drone footage that keeps playing behind the whole home page.
// Landscape footage on landscape screens, portrait footage on phones held upright,
// so each clip is shown at its native aspect ratio (no blurry upscaling).
export default function BackgroundVideo() {
  const videoRef = useRef(null);
  const [portrait, setPortrait] = useState(() => window.matchMedia("(orientation: portrait)").matches);

  useEffect(() => {
    const mq = window.matchMedia("(orientation: portrait)");
    const onChange = (e) => setPortrait(e.matches);
    mq.addEventListener("change", onChange);
    document.body.classList.add("home-video");
    // Some browsers (iOS low-power mode) block autoplay until the first touch/scroll: retry then.
    const tryPlay = () => { const v = videoRef.current; if (v && v.paused) v.play().catch(() => {}); };
    const events = ["touchstart", "scroll", "click", "keydown"];
    events.forEach((ev) => window.addEventListener(ev, tryPlay, { passive: true }));
    return () => {
      mq.removeEventListener("change", onChange);
      document.body.classList.remove("home-video");
      events.forEach((ev) => window.removeEventListener(ev, tryPlay));
    };
  }, []);

  const src = portrait ? "/media/brand-hero.mp4" : "/media/drone-playa.mp4";
  const poster = portrait ? "/media/brand-poster.jpg" : "/media/drone-poster.jpg";

  return (
    <div className="fixed inset-0 -z-10 bg-[#0b1f33]" aria-hidden="true" data-testid="background-video">
      <video
        key={src}
        ref={videoRef}
        className="absolute inset-0 w-full h-full object-cover"
        src={src}
        poster={poster}
        autoPlay
        loop
        muted
        playsInline
        preload="auto"
        onLoadedData={(e) => e.currentTarget.play().catch(() => {})}
      />
      <div className="absolute inset-0 bg-[#0b1f33]/40" />
      <div className="absolute inset-0 bg-gradient-to-b from-[#0b1f33]/60 via-transparent to-[#0b1f33]/70" />
    </div>
  );
}
